export const INTENT_CAPABILITY = 'data-forq-ext-intents';
/** Old extensions select the newest venue promise and ignore its context. */
export function needsIntentUpdate(): boolean {
  if (typeof document === 'undefined') return false;
  const node = document.documentElement;
  return node.hasAttribute('data-forq-ext') && node.getAttribute(INTENT_CAPABILITY) !== '1';
}
